











































































































import TextDatePicker from '@/views/molecules/TextDatePicker.vue'
import BlueButton from '@/views/atoms/BlueButton.vue'
import store from '@/store'
import TextBox from '@/views/atoms/TextBox.vue'
import CheckBox from '@/views/atoms/CheckBox.vue'
import PopupPreview from '@/views/template/PopupPreview.vue'
import PopupComfirmSave from '@/views/template/PopupComfirmSave.vue'
import ApiClient from '@/common/api'
import ErrorLabel from '@/views/atoms/ErrorLabel.vue'
import PopupComplete from '@/views/template/PopupComplete.vue'

export default
  components: {
    TextDatePicker
    BlueButton
    TextBox
    CheckBox
    PopupPreview
    PopupComfirmSave
    ErrorLabel
    PopupComplete
  }
  props:
    supplySourceNum:
      type: String
      default: ''

  data: () ->
    emailType: '1'
    supplySource: ''
    toyonakaSaveMail: ''
    toyonakaEditMail: ''
    toyonakaCancelMail: ''
    toyonakaCompleteMail: ''
    suitaSaveMail: ''
    suitaEditMail: ''
    suitaCancelMail: ''
    suitaCompleteMail: ''
    previewData: {}
    isShowPopup: {}
    complete: ''

  watch: {
    supplySourceNum: (v) ->
      @supplySource = v
  }

  created: () ->
    store.dispatch('setErrors', [])
    @supplySource = @supplySourceNum
    api = new ApiClient()
    data = await api.get('/admin/mail/list')
    @toyonakaSaveMail = data.list[1].save
    @toyonakaEditMail = data.list[1].edit
    @toyonakaCancelMail = data.list[1].cancel
    @toyonakaCompleteMail = data.list[1].complete
    @suitaSaveMail = data.list[2].save
    @suitaEditMail = data.list[2].edit
    @suitaCancelMail = data.list[2].cancel
    @suitaCompleteMail = data.list[2].complete

  methods: {
    save: () ->
      param =
        toyonaka:
          save: @toyonakaSaveMail
          edit: @toyonakaEditMail
          cancel: @toyonakaCancelMail
          complete: @toyonakaCompleteMail
        suita:
          save: @suitaSaveMail
          edit: @suitaEditMail
          cancel: @suitaCancelMail
          complete: @suitaCompleteMail
      api = new ApiClient()
      data = await api.post('/admin/mail/save', param)
      num = 0
      for r, i in data.errors
        if Object.keys(r).length != 0
          store.dispatch('setErrors', r)
          num++
      @closePopup('save')
      if num == 0
        @complete = '保存'
        @showPopup('complete')
    mailType: (e) ->
      @emailType = e

    # 豊中の予約登録
    tSaveChange: (e) ->
      @toyonakaSaveMail.text =  e.target.value
    tTitleSaveChange: (e) ->
      @toyonakaSaveMail.title = e.val
    tFromSaveChange: (e) ->
      @toyonakaSaveMail.from = e.val
    # 豊中の予約変更
    tEditChange: (e) ->
      @toyonakaEditMail.text = e.target.value
    tTitleEditChange: (e) ->
      @toyonakaEditMail.title = e.val
    tFromEditChange: (e) ->
      @toyonakaEditMail.from = e.val
    # 豊中の予約キャンセル
    tCancelChange: (e) ->
      @toyonakaCancelMail.text = e.target.value
    tTitleCancelChange: (e) ->
      @toyonakaCancelMail.title = e.val
    tFromCancelChange: (e) ->
      @toyonakaCancelMail.from = e.val
    # 豊中の充填完了
    tCompleteChange: (e) ->
      @toyonakaCompleteMail.text = e.target.value
    tTitleCompleteChange: (e) ->
      @toyonakaCompleteMail.title = e.val
    tFromCompleteChange: (e) ->
      @toyonakaCompleteMail.from = e.val

    # 吹田の予約登録
    sSaveChange: (e) ->
      @suitaSaveMail.text =  e.target.value
    sTitleSaveChange: (e) ->
      @suitaSaveMail.title = e.val
    sFromSaveChange: (e) ->
      @suitaSaveMail.from = e.val
    # 吹田の予約変更
    sEditChange: (e) ->
      @suitaEditMail.text = e.target.value
    sTitleEditChange: (e) ->
      @suitaEditMail.title = e.val
    sFromEditChange: (e) ->
      @suitaEditMail.from = e.val
    # 吹田の予約キャンセル
    sCancelChange: (e) ->
      @suitaCancelMail.text = e.target.value
    sTitleCancelChange: (e) ->
      @suitaCancelMail.title = e.val
    sFromCancelChange: (e) ->
      @suitaCancelMail.from = e.val
    # 吹田の充填完了
    sCompleteChange: (e) ->
      @suitaCompleteMail.text = e.target.value
    sTitleCompleteChange: (e) ->
      @suitaCompleteMail.title = e.val
    sFromCompleteChange: (e) ->
      @suitaCompleteMail.from = e.val

    copy: (e) ->
      copyTarget = '{' + e.target.value + '}'
      navigator.clipboard.writeText(copyTarget)
    preview: () ->
      if @supplySource == '1'
        if @emailType == '1'
          @previewData = @toyonakaSaveMail
        else if @emailType == '2'
          @previewData = @toyonakaEditMail
        else if @emailType == '3'
          @previewData = @toyonakaCancelMail
        else if @emailType == '4'
          @previewData = @toyonakaCompleteMail
      else if @supplySource == '2'
        if @emailType == '1'
          @previewData = @suitaSaveMail
        else if @emailType == '2'
          @previewData = @suitaEditMail
        else if @emailType == '3'
          @previewData = @suitaCancelMail
        else if @emailType == '4'
          @previewData = @suitaCompleteMail
      @showPopup('preview')
    showPopup: (property) ->
      @$set(@isShowPopup, property, true)
    closePopup: (property) ->
      @$set(@isShowPopup, property, false)
  }
